import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import WhatIsBushMap from "@/components/WhatIsBushMap";
import WhyBushMapping from "@/components/WhyBushMapping";
import BushMapIncludes from "@/components/BushMapIncludes";
import BushMapProcess from "@/components/BushMapProcess";
import ExampleMaps from "@/components/ExampleMaps";
import CommunityProvide from "@/components/CommunityProvide";
import ProjectOutputs from "@/components/ProjectOutputs";
import CommunityAuthority from "@/components/CommunityAuthority";
import KnowledgeSystems from "@/components/KnowledgeSystems";
import ExampleOutcomes from "@/components/ExampleOutcomes";
import LunacalBooking from "@/components/LunacalBooking";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [hash]);

  return (
    <main className="bg-[#FDFBF7] text-[#2D2621]">
      <Nav />
      <Hero />
      <WhatIsBushMap />
      <WhyBushMapping />
      <BushMapIncludes />
      <BushMapProcess />
      <ExampleMaps />
      <CommunityProvide />
      <ProjectOutputs />
      <CommunityAuthority />
      <KnowledgeSystems />
      <ExampleOutcomes />
      <LunacalBooking />
      <ContactForm />
      <Footer />
    </main>
  );
}
